<template>
    <el-dialog title="发货申请单管理" :visible.sync="isShowDialog" :before-close="handleClose" width="1200px" :close-on-click-modal="false">
        <div class="details-box">
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">配送省市 ：</div>
                            <div class="is-status-text">{{ addressStr }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">配送地址：</div>
                            <div>{{ detailsInfo.Orders_Delivery_Address }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收货人 ：</div>
                            <div>{{ detailsInfo.Orders_Delivery_Accepter }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收货人电话：</div>
                            <div>{{ detailsInfo.Orders_Delivery_Mobile }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">工程名称 ：</div>
                            <div>{{ detailsInfo.Orders_ProjectName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">时间：</div>
                            <div>{{ detailsInfo.Orders_Delivery_Addtime|formatDates }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">发货状态 ：</div>
                            <div>
                                <span :class="judgeColor(detailsInfo.Orders_Delivery_FreightStatus)">{{ detailsInfo.Orders_Delivery_FreightStatus }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">发货类型：</div>
                            <div>{{ detailsInfo.DeliveryTypeName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">同步状态：</div>
                            <div>
                                <span :class="judgeColor(detailsInfo.DeliverySyncStatus)">{{ detailsInfo.DeliverySyncStatus }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">下达确认状态：</div>
                            <div>

                                <span :class="judgeColor(detailsInfo.Orders_Delivery_PaperConfirmName)">{{ detailsInfo.Orders_Delivery_PaperConfirmName }}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="detailsInfo.Orders_Delivery_PaperConfirm == '0'">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">审批员：</div>
                            <div>{{ detailsInfo.managername }}</div>
                        </div>
                    </el-col>
                </el-row>
                <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="Detail_ProductName" show-overflow-tooltip label="商品名称" align="left"></el-table-column>
                    <el-table-column prop="Detail_Quantity" label="发货数量" align="center" width="120"></el-table-column>
                    <el-table-column prop="DeliverySyncStatusName" label="同步状态" align="center" width="150">
                        <template slot-scope="scope">
                            <span :class="judgeColor(scope.row.DeliverySyncStatusName)">{{ scope.row.DeliverySyncStatusName }}</span>
                        </template>
                    </el-table-column>
                     <el-table-column prop="Detail_RMA_BatchNo" label="退货批次号" align="center" width="120" v-if="detailsInfo.DeliveryTypeName=='挪货'"></el-table-column>
                    <el-table-column label="备注" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.Detail_PreparationNote }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
            <el-button @click="handleClose()">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { getDisplayAddressStr } from '@/utils/utils.js'
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: () => false
    },
    Orders_Delivery_ID: {
      type: String
    }
  },
  watch: {
    isShowDialog (newval, oldval) {
      console.log(newval, this.Orders_Delivery_ID)
      if (newval) {
        this.getOrdersDeliveryByID()
        this.getOrdersDeliveryGoods()
      }
    }
  },
  data () {
    return {
      tableData: [],
      detailsInfo: { Orders_Delivery_Address: '', Orders_Delivery_Accepter: '', Orders_Delivery_Mobile: '' },
      addressStr: ''
    }
  },
  methods: {
    //关闭弹窗
    handleClose () {
      this.$emit('handleClose', false)
    },
    //获取详情信息
    getOrdersDeliveryByID () {
      this.$newsApi.getOrdersDeliveryByID({ Orders_Delivery_ID: this.Orders_Delivery_ID }).then(res => {
        if (res.data.Resultcode == 0) {
          if (res.data.data && res.data.data.length > 0) {
            this.detailsInfo = res.data.data[0]
            getDisplayAddressStr(this.detailsInfo.Orders_Delivery_Country, this.detailsInfo.Orders_Delivery_State, this.detailsInfo.Orders_Delivery_City, this.detailsInfo.Orders_Delivery_County, (result) => {
              this.addressStr = result.resultinfo
              console.log(result)
            }, (err) => {
              console.log(err)
            })
          }
        }
      })
    },
    //获取详情表格内容
    getOrdersDeliveryGoods () {
      this.$newsApi.getOrdersDeliveryGoods({ ID: this.Orders_Delivery_ID }).then(res => {
        if (res.data.Resultcode == 0) {
          this.tableData = res.data.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
.is-status-text{
  color:#cc0000;
}
</style>